import { useMemo } from "react";

import { ThumbUp } from "components/icons/generated";
import { isSaasDistribution } from "utils/distribution";
import { MainNavigationItem } from "components/MainNavigation/types";
import useTypedFlags from "hooks/useTypedFlags";

import {
  MAIN_NAVIGATION_SECONDARY_MENU_ITEMS,
  MainNavigationSecondaryMenuItemKeys,
} from "./menuItemsSecondary";

export const FEATUREBASE_URL = "https://feedback.spacelift.io/";
export const SUPPORT_GROUP_ID = "support";

const SUPPORT_EMAIL = "support@spacelift.io";

const isSaas = isSaasDistribution();

const useFeedbackItemSaaS = (): MainNavigationItem | undefined => {
  const { pylonChatVisbility } = useTypedFlags();

  const supportChatItem = useMemo(() => {
    const item =
      MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.SupportChat];

    if (pylonChatVisbility) {
      return item;
    }

    return {
      ...item,
      title: "Contact support",
      onAction: undefined,
      href: `mailto:${SUPPORT_EMAIL}`,
    };
  }, [pylonChatVisbility]);

  const item = useMemo(
    () => ({
      id: SUPPORT_GROUP_ID,
      title: "Support & Feedback",
      icon: ThumbUp,
      items: [
        {
          items: [
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.ProductUpdates
            ],
            supportChatItem,
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.KeyboardShortcuts
            ],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.Documentation],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[MainNavigationSecondaryMenuItemKeys.KnowledgeBase],
          ],
        },
        {
          title: "Feedback",
          items: [
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.RequestFeature
            ],
            MAIN_NAVIGATION_SECONDARY_MENU_ITEMS[
              MainNavigationSecondaryMenuItemKeys.FeedbackDashboard
            ],
          ],
        },
      ],
    }),
    [supportChatItem]
  );

  if (!isSaas) {
    return undefined;
  }

  return item;
};

export default useFeedbackItemSaaS;
